import React from 'react';
import { Hero } from './components/Hero';
import { Story } from './components/Story';
import { WhyItMatters } from './components/WhyItMatters';
import { Features } from './components/Features';
import { Audience } from './components/Audience';
import { CallToAction } from './components/CallToAction';
import { Footer } from './components/Footer';
import { RecentSalesNotifications } from './components/RecentSalesNotifications';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Hero data-id="element-1" />
      <Story data-id="element-2" />
      <WhyItMatters data-id="element-3" />
      <Features data-id="element-4" />
      <Audience data-id="element-5" />
      <CallToAction data-id="element-6" />
      <Footer data-id="element-7" />
      <RecentSalesNotifications data-id="element-8" />
    </div>;
}